import type { ReactElement } from "react";
import { AdminPage, AdminPageHeader } from "./admin-ui";
import { QueuePriorityPolicySection } from "./next-ranking-admin/QueuePriorityPolicySection";
import { TaskTypeWeightsSection } from "./next-ranking-admin/TaskTypeWeightsSection";

// ---------------------------------------------------------------------------
// Next ranking admin — the two governed config stores that tune the Next
// dispenser's ranking (docs/NEXT.md — Queue priority policy + Task-type
// weights). Both are read/full-replace; neither affects correctness, only
// ranking quality, so a bad edit degrades to a worse pick, never a wrong
// serve.
//
// AdminLayout owns the chrome (top bar + AdminBar). This page only
// constrains its own content width, matching the sibling admin pages.
// ---------------------------------------------------------------------------

export function NextRankingAdminPage(): ReactElement {
    return (
        <AdminPage>
            <AdminPageHeader
                title="Next ranking"
                description="Tune how the Next dispenser ranks work items. These settings change ranking quality only — never which items are eligible or how locks are enforced."
            />
            <QueuePriorityPolicySection />
            <TaskTypeWeightsSection />
        </AdminPage>
    );
}
